// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__XV8Ib","vatRate":"styles_vatRate__bn_uO","vatRateLabel":"styles_vatRateLabel__yMarM","slideInSearchBar":"styles_slideInSearchBar__LKq3h"};